"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = exports.SalesIntelligence = exports.PipelineIntelligence = exports.Insights = exports.ConversationalEmail = exports.Advertising = exports.Abm = exports.APP_TO_ICON_MAP = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var Abm_1 = __importDefault(require("./Abm"));
exports.Abm = Abm_1.default;
var Advertising_1 = __importDefault(require("./Advertising"));
exports.Advertising = Advertising_1.default;
var ConversationalEmail_1 = __importDefault(require("./ConversationalEmail"));
exports.ConversationalEmail = ConversationalEmail_1.default;
var Insights_1 = __importDefault(require("./Insights"));
exports.Insights = Insights_1.default;
var PipelineIntelligence_1 = __importDefault(require("./PipelineIntelligence"));
exports.PipelineIntelligence = PipelineIntelligence_1.default;
var SalesIntelligence_1 = __importDefault(require("./SalesIntelligence"));
exports.SalesIntelligence = SalesIntelligence_1.default;
var Workflow_1 = __importDefault(require("./Workflow"));
exports.Workflow = Workflow_1.default;
exports.APP_TO_ICON_MAP = {
    ABM: Abm_1.default,
    ADS: Advertising_1.default,
    CE: ConversationalEmail_1.default,
    // INSIGHTS: Insights,
    PI: PipelineIntelligence_1.default,
    SI: SalesIntelligence_1.default,
    WORKFLOWS: Workflow_1.default,
};
var AppIcon = function (_a) {
    var app = _a.app, size = _a.size, theme = _a.theme;
    var Icon = exports.APP_TO_ICON_MAP[app] || Abm_1.default;
    return react_1.jsx(Icon, { size: size, theme: theme });
};
exports.default = AppIcon;
